import { HTTPClient } from "./Client";

const UsuarioApi = {

    async listarStatusUsuarioAsync() {
        const response = await HTTPClient.get(`/Usuario/ListarStatusUsuario`);
        return response.data;
    },

    async ListarUsuariosPorGrupoDeUsuarioAsync(grupoDeUsuario) {
        const response = await HTTPClient.get(`/Usuario/ListarUsuariosPorGrupoDeUsuario/${grupoDeUsuario}`);
        return response.data;
    },

    async ObterIdsUsuariosDasTurmas(turmasIds) {
        const queryString = turmasIds.map(id => `turmaIds=${id}`).join('&');
        const response = await HTTPClient.get(`/Usuario/ListarUsuariosAlunosPorTurmas?${queryString}`);
        return response.data;
    },

    async ListarUsuariosAlunosVinculadosAoMonitor() {
        const response = await HTTPClient.get(`/Usuario/ListarUsuariosAlunosVinculadosAoMonitor`);
        return response.data;
    }
}

export default UsuarioApi;